import React, { useContext, useState } from "react";
import { IoMdInformationCircle } from "react-icons/io";
import { DistributorFormContext } from "./FormContext";
import { FaAngleLeft } from "react-icons/fa6";
import axios from "axios";
import ImageLoading from "../../../components/ImageLoading";

function StepTwoForm({
  setFormStep,
  fetchUsers,
  setAddNewModal,
  setAddedSuccess,
  setExistError,
  editData,
  setAddErrorMessage,
}) {
  const {
    name,
    email,
    creditType,
    selectedImage,
    earningFeesType,
    setEarningFeesType,
    earningAmountType,
    setEarningAmountType,
    earningFeesValue,
    setEarningFeesValue,
    earningAmountValue,
    setEarningAmountValue,
    applicableFeesValue,
    setApplicableFeesValue,
    applicableRateValue,
    setApplicableRateValue,
    existLogo,
    loading,
  } = useContext(DistributorFormContext);
  const token = localStorage.getItem("token");
  const [earningFeeError, setEarningFeeError] = useState(null);
  const [earningAmountError, setEarningAmountError] = useState(null);
  const [applicableFeeError, setApplicableFeeError] = useState(null);
  const [applicableRateError, setApplicableRateError] = useState(null);

  const handleAddDistributor = () => {
    const formData = new FormData();
    const appendIfNotEmpty = (key, value) => {
      if (value !== "" && value !== null) formData.append(key, value);
    };

    formData.append("name", name);
    formData.append("email", email);
    formData.append("credit_type", creditType);

    // Append conditional fee and loan values
    appendIfNotEmpty(
      `distributor_detail[earning_processing_fee_${
        earningFeesType === "%" ? "percentage" : "inr"
      }]`,
      earningFeesValue
    );
    appendIfNotEmpty(
      `distributor_detail[earning_loan_amount_${
        earningAmountType === "%" ? "percentage" : "inr"
      }]`,
      earningAmountValue
    );
    appendIfNotEmpty(
      "distributor_detail[roi_processing_fee_percentage]",
      applicableFeesValue
    );
    appendIfNotEmpty(
      "distributor_detail[rate_of_interest_percentage]",
      applicableRateValue
    );

    // Append image if it exists
    if (selectedImage) {
      formData.append("logo_image", selectedImage);
    }

    axios
      .post(`${process.env.REACT_APP_URL}/lender/distributors`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": `multipart/form-data`,
        },
      })
      .then((response) => {
        if (response.data.error) {
          setExistError("Error adding distributor details");
          setAddNewModal(false);
          return;
        }
        if (response.status === 200) {
          setAddNewModal(false);

          setAddedSuccess("Distributor added successfully");
          const controller = new AbortController();
          fetchUsers(controller);
        }
      })
      .catch((err) => {
        console.log(err);
        setAddNewModal(false);
        setAddErrorMessage(
          err?.response?.data?.error === "This Distributor is already exists"
            ? "Distributor already exists"
            : "Error adding the distributor"
        );
        setExistError(true);
      });
  };
  const handleUpdateAddDistributor = () => {
    const formData = new FormData();

    // Append data to formData
    formData.append("name", name);
    formData.append(
      `earning_processing_fee_${
        earningFeesType === "%" ? "percentage" : "inr"
      }`,
      earningFeesValue
    );
    formData.append(
      `earning_processing_fee_${
        earningFeesType === "%" ? "inr" : "percentage"
      }`,
      0
    );
    formData.append(
      `earning_loan_amount_${earningAmountType === "%" ? "percentage" : "inr"}`,
      earningAmountValue
    );
    formData.append(
      `earning_loan_amount_${earningAmountType === "%" ? "inr" : "percentage"}`,
      0
    );

    formData.append("roi_processing_fee_percentage", applicableFeesValue);
    formData.append("rate_of_interest_percentage", applicableRateValue);
    if (selectedImage === null && existLogo == null) {
      formData.append("logo_image", "remove_logo");
    }

    selectedImage && formData.append("logo_image", selectedImage);

    axios
      .put(
        `${process.env.REACT_APP_URL}/lender/update_distributor_details/${editData.id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": `multipart/form-data`,
          },
        }
      )
      .then((response) => {
        if (response.data.error) {
          setExistError(true);
          setAddNewModal(false);
          return;
        }
        if (response.status === 200) {
          setAddNewModal(false);

          setAddedSuccess("Distribution details updated successfully");
          const controller = new AbortController();
          fetchUsers(controller);
        }
      })
      .catch((err) => {
        console.log(err);
        setAddNewModal(false);
        setExistError(true);
      });
  };

  const handleValueError = () => {
    if (earningFeesType === "%" && earningFeesValue > 100) {
      setEarningFeeError("% Value should be less than 100");
      return;
    }
    if (earningAmountType === "%" && earningAmountValue > 100) {
      setEarningAmountError("% Value should be less than 100");
      return;
    }
    if (applicableFeesValue > 100) {
      setApplicableFeeError("% Value should be less than 100");
      return;
    }
    if (applicableRateValue > 100) {
      setApplicableRateError("% Value should be less than 100");
      return;
    }
    if (
      !applicableFeeError &&
      !applicableRateError &&
      !earningFeeError &&
      !earningAmountError
    ) {
      if (editData) {
        handleUpdateAddDistributor();
      } else {
        handleAddDistributor();
      }
    }
  };
  return (
    <>
      {loading && (
        <div className=" w-full h-full flex justify-center items-center">
          <ImageLoading />
        </div>
      )}
      {!loading && (
        <form className=" mt-6">
          <div className=" w-full min-h-[198px] bg-[#f3f3f3] p-4 rounded-lg">
            <p className=" text-sm font-semibold flex items-center">
              {" "}
              <span> Earning Computation </span>
              <span
                className=" ml-1 mt-[2px]"
                title="This values will be use to compute earning report."
              >
                <IoMdInformationCircle size={17} color="#00394d" />
              </span>
            </p>
            <div className=" w-full min-h-[125px] flex justify-between ">
              <ValueComponent
                name={"Processing fees (per loan)"}
                state={earningFeesType}
                setState={setEarningFeesType}
                textState={earningFeesValue}
                setTextState={setEarningFeesValue}
                error={earningFeeError}
                setError={setEarningFeeError}
              />
              <ValueComponent
                name={"Loan Amount (per loan)"}
                state={earningAmountType}
                setState={setEarningAmountType}
                textState={earningAmountValue}
                setTextState={setEarningAmountValue}
                error={earningAmountError}
                setError={setEarningAmountError}
              />
            </div>
          </div>
          <div className=" w-full min-h-[198px] bg-[#f3f3f3] p-4 rounded-lg mt-6">
            <p className=" text-sm font-semibold flex items-center">
              {" "}
              <span> Applicable ROI </span>
              <span
                className=" ml-1 mt-[2px]"
                title="This values will be use to compute earning report."
              >
                <IoMdInformationCircle size={17} color="#00394d" />
              </span>
            </p>
            <div className=" w-full min-h-[125px] flex justify-between ">
              <ValueComponent
                name={"Processing fees (per loan)"}
                percentage={"%"}
                textState={applicableFeesValue}
                setTextState={setApplicableFeesValue}
                error={applicableFeeError}
                setError={setApplicableFeeError}
              />
              <ValueComponent
                name={"Interest Rate (per loan)"}
                percentage={"%"}
                textState={applicableRateValue}
                setTextState={setApplicableRateValue}
                error={applicableRateError}
                setError={setApplicableRateError}
              />
            </div>
          </div>
          <div className=" flex justify-between items-center mt-8 ">
            <button
              onClick={() => setFormStep(1)}
              className=" flex items-center"
            >
              <FaAngleLeft width={8} height={4} />
              <span className=" ml-1 text-sm text-[#00394d] font-semibold">
                Back
              </span>
            </button>
            <div className=" flex items-center">
              <p className=" text-sm text-[#848484] mr-4">2 of 2 steps</p>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleValueError();
                }}
                className=" bg-[#00394d] text-white h-[32px] w-[142px] rounded-lg text-sm font-semibold"
              >
                Save Distributor
              </button>
            </div>
          </div>
        </form>
      )}
    </>
  );
}

export default StepTwoForm;

const ValueComponent = ({
  name,
  state,
  setState,
  percentage,
  textState,
  setTextState,
  error,
  setError,
}) => {
  return (
    <div className=" w-[46%] h-full  mt-6">
      <p className=" text-sm font-semibold">{name}</p>
      {!percentage && (
        <div className=" flex justify-between mt-[20px]">
          <input
            type="radio"
            name={name}
            value="%"
            checked={state === "%"}
            onChange={(e) => {
              setError(null);
              setState(e.target.value);
            }}
          />{" "}
          <label className=" text-sm font-medium">% Value</label>
          <input
            type="radio"
            name={name}
            value="INR"
            checked={state === "INR"}
            onChange={(e) => {
              setError(null);
              setState(e.target.value);
            }}
          />{" "}
          <label className=" text-sm font-medium">INR Value</label>
        </div>
      )}
      {percentage && <p className="mt-[20px] text-sm font-medium">% Value</p>}

      <div className=" w-full border border-[#e0e0e0] flex justify-between px-4 bg-white rounded mt-3 items-center">
        <input
          value={textState}
          onChange={(e) => {
            setError(null);
            let input = e.target.value;
            input = input.replace(/[^\d.]/g, "");
            setTextState(input);
          }}
          placeholder="e.g., 25"
          className=" w-[85%] focus:outline-none text-sm h-9 text-[#00394d] font-medium placeholder:text-[#848484]"
          type="text"
        />
        <p className=" text-sm text-[#848484]">{state ? state : percentage}</p>
      </div>
      <p className=" text-xs mt-2 text-[#656565] font-medium">
        Processing fees (Per loan)
      </p>
      {error && <p className="text-[11px] mt-2 text-red-500">{error}</p>}
    </div>
  );
};
